<template>
  <div class="home_page">
    <el-row  class="tac">
      <el-col :span="4" class="nav">
        <el-menu :default-active="defaultActive" style="min-height: 100%;text-align: left;" theme="dark" router>
          <el-menu-item index="welcome"><i class="iconfont icon-gonggao icon"></i>首页</el-menu-item>
          <el-submenu index="xmlx">
		        <template slot="title"><i class="iconfont icon-shuzi1 icon"></i>题目</template>
		        <el-menu-item index="problemList">题目列表</el-menu-item>
            <el-menu-item index="createProblem">出题</el-menu-item>
            <el-menu-item index="prepareProblemList">待审核题目</el-menu-item>
            <el-menu-item index="prepareProblemListUser">用户提交的题目</el-menu-item>
		      </el-submenu>
		      <el-submenu index="gzfa">
            <template slot="title"><i class="iconfont icon-shuzi2 icon"></i>相关知识</template>
            <el-menu-item index="knowledgeList">知识列表</el-menu-item>
          </el-submenu>
          <el-submenu index="xmss">
            <template slot="title"><i class="iconfont icon-shuzi3 icon"></i>辅助功能</template>
            <el-menu-item index="managerPage">管理页面</el-menu-item>
            <el-menu-item index="noticePage">公告管理</el-menu-item>
            <el-menu-item index="upload2Oss">上传资源到OSS</el-menu-item>
          </el-submenu>
          <el-menu-item index="newTeamList"><i class="iconfont icon-weibiaoti1 icon"></i>新团队审核</el-menu-item>
          <el-menu-item index="jhxm"><i class="iconfont icon-weibiaoti1 icon"></i>注册人数统计</el-menu-item>
          <el-menu-item index="txxt"><i class="iconfont icon-tuxing icon"></i>用户分析</el-menu-item>
          <el-menu-item index="yjjy"><i class="iconfont icon-tuxing icon"></i>意见建议</el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="20" style="height: calc(100vh - 56px);overflow-y: auto;overflow-x: hidden;">
        <transition mode="out-in"
          enter-active-class="animated fadeInLeft"
          leave-active-class="animated fadeOutRight">
          <router-view class="router"></router-view>
        </transition>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    computed: {
      defaultActive: function () {
        return this.$route.path.replace('/home/', '')
      }
    },
    mounted () {
    },
    methods: {
      handleOpen (key, keyPath) {
        console.log(key, keyPath)
      },
      handleClose (key, keyPath) {
        console.log(key, keyPath)
      }
    }
  }
</script>

<style>
  .home_page,
  .tac{
    min-height: calc(100vh - 56px);
    overflow-y: hidden;
  }
  .nav{
    height: calc(100vh - 56px);
    background-color: #324057;
    overflow-y: auto;
  }
  .threeMenu{
    background-color: black;
  }

  .router{
    box-shadow: none;
    animation-duration: .5s;
  }
  .icon{
    padding: 0 10px;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// home.vue?78e991c7